module.exports = __webpack_public_path__ + "img/mock_qua.c72ad128.jpg";